import { Routes } from '@angular/router';
import { MainLayoutComponent } from './components/shared/main-layout/main-layout.component';
import { LoginComponent } from './components/pages/public/login/login.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard.component';
import { authGuard } from './auth.gaurd';
import { NewPasswordComponent } from './components/pages/public/new-password/new-password.component';
import { ForcePasswordChangeComponent } from './components/pages/public/force-password-change/force-password-change.component';
import { SearchComponent } from './components/shared/main-layout/search/search.component';
import { NotificationsComponent } from './components/shared/notifications/notifications.component';
import { InvalidComponent } from './components/pages/public/invalid/invalid.component';
import { GmailAuthResultComponent } from './components/pages/public/gmail-auth-result/gmail-auth-result.component';
import { SearchDetailsComponent } from './components/shared/main-layout/search-details/search-details.component';
import { SetDndComponent } from './components/shared/main-layout/set-dnd/set-dnd.component';
import { requireCapability } from './components/shared/permissions/permissions.guard';
import { CAPS } from './components/shared/permissions/capabilities.constants';

export const routes: Routes = [
    { path: '', redirectTo: 'app', pathMatch: 'full' },
    {
        path: 'preview-action-centre',
        loadChildren: () => import('./components/pages/terminal-crm/terminal-crm.routes').then(m => m.routes),
    },
    {
        path: 'app',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard', component: DashboardComponent
            },
            {
                path: 'assignments',
                loadChildren: () => import('./components/pages/assignments/assignments.routes').then(m => m.routes),
            },
            {
                path: 'handle-assignments',
                loadComponent: () => import('./components/pages/handle-assignments/handle-assignments.component').then(m => m.HandleAssignmentsComponent),
            },
            {
                path: 'email-blasting',
                loadComponent: () => import('./components/pages/email-blasting/email-blasting.component').then(m => m.EmailBlastingComponent),
            },
            {
                path: 'contracts',
                loadChildren: () => import('./components/pages/contracts/contracts.routes').then(m => m.routes),
            },
            {
                path: 'contract-changes',
                loadChildren: () => import('./components/pages/contract-changes/contract-changes.routes').then(m => m.routes),
            },
            {
                path: 'proposal',
                loadChildren: () => import('./components/pages/proposal/proposal.routes').then(m => m.routes),
            },
            {
                path: 'users',
                loadChildren: () => import('./components/pages/users/users.routes').then(m => m.routes),
            },
            {
                path: 'leads',
                loadChildren: () => import('./components/pages/leads/leads.routes').then(m => m.routes),
            },
            {
                path: 'sales',
                loadChildren: () => import('./components/pages/sales/sales.routes').then(m => m.routes),
            },
            {
                path: 'business',
                loadChildren: () => import('./components/pages/business/business.routes').then(m => m.routes),
            },
            {
                path: 'debt-recovery',
                loadChildren: () => import('./components/pages/debt-recovery/debt-recovery.routes').then(m => m.routes),
            },
            {
                path: 'claims',
                loadChildren: () => import('./components/pages/claims/claims.routes').then(m => m.routes),
            },
            {
                path: 'training',
                loadChildren: () => import('./components/pages/training/training.routes').then(m => m.routes),
            },
            {
                path: 'marketing',
                loadChildren: () => import('./components/pages/marketing/marketing.routes').then(m => m.routes),
            },
            {
                path: 'internal-tickets',
                loadChildren: () => import('./components/pages/internal-ticket/internal-ticket.routes').then(m => m.routes),
            },
            {
                path: 'admin-settings',
                loadChildren: () =>
                    import('./components/pages/admin-settings/admin-settings.routes').then(m => m.routes),
            },
            // Standalone top-level menu, not part of the RBAC module --
            // path must match the fm_static.menus row's `path` column
            // exactly (app/email-sync) or RouteAuthService#checkRouteAccess
            // 404s it for every admin, even one granted the menu.
            {
                path: 'email-sync',
                loadComponent: () =>
                    import('./components/pages/email-sync/email-sync.component').then(m => m.EmailSyncComponent),
            },
            {
                path: 'payments',
                loadChildren: () => import('./components/pages/payments/payments.routes').then(m => m.routes),
            },
            {
                path: 'collections',
                loadChildren: () => import('./components/pages/collections/collections.routes').then(m => m.routes),
            },
            {
                path: 'settings',
                loadChildren: () => import('./components/pages/settings/settings.routes').then(m => m.routes),
            },
            {
                path: 'ach',
                loadChildren: () => import('./components/pages/ACH/ach-routes').then(m => m.routes),
            },
            {
                path: 'customers',
                loadChildren: () => import('./components/pages/customers/customers.routes').then(m => m.routes),
            },
            {
                path: 'bsa',
                loadChildren: () => import('./components/pages/bsa/bsa.routes').then(m => m.routes),
            },
            {
                path: 'utm-parameters',
                loadChildren:() => import('./components/pages/utmparameters/utmparameter.routes').then(m => m.routes)
            },
            {
                path: 'terminal',
                loadChildren: () => import('./components/pages/terminal/terminal.routes').then(m => m.routes),
            },
            {
                path: 'terminal-crm',
                loadChildren: () => import('./components/pages/terminal-crm/terminal-crm.routes').then(m => m.routes),
            },
            {
                path: 'search', component: SearchComponent
            },
            {
                path: 'details-search', component: SearchDetailsComponent
            },
            {
                path: 'notifications',
                component: NotificationsComponent
            },   
            {
                path: 'notifications/:id',
                component: NotificationsComponent
            },
            { path: 'dnd-profile', component: SetDndComponent },
            { path: '404', component: InvalidComponent },
            {
                path: 'home',
                loadChildren:() => import('./components/pages/home/home.routes').then(m => m.routes)
            },
            {
                path: 'rbac',
                canActivate: [requireCapability(CAPS.RBAC.MANAGE)],
                loadChildren: () => import('./components/pages/rbac/rbac.routes').then(m => m.routes),
            },
            {
                path: 'payment-processing/list',
                loadChildren: () => import('./components/pages/process-payment/process-payment.routes').then(m => m.routes)
            },
            {
                path: 'subscriptions',
                loadChildren: () => import('./components/pages/subscriptions/subscriptions.routes').then(m => m.routes)
            },
            {
                path: 'email-events-dashboard',
                loadChildren: () => import('./components/pages/email-events-dashboard/email-events-dashboard.routes').then(m => m.routes)
            }


        ],
    },
    // { path: '**', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    { path: 'new-password', component: NewPasswordComponent },
    { path: 'force-password-change', component: ForcePasswordChangeComponent },
    // Lands the Google OAuth POPUP window, not the main tab -- see
    // connectGmail() in main-layout.component.ts. Deliberately outside the
    // `app` route tree so it isn't behind authGuard: a popup freshly
    // returned from Google carries no Authorization header to present.
    { path: 'gmail-auth-result', component: GmailAuthResultComponent }
];
